<template>
  <v-card class="ma-2">
    <v-row no-gutters>
      <v-col cols="12">
        <v-img :aspect-ratio="16/9" :src="thumb_1">
          <v-card-title class="align-start">
            <v-layout align-center justify-start row spacer>
              <v-flex shrink>
                <v-chip
                  label
                  v-if="featured"
                  color="primary"
                  class="mx-2 mb-2"
                >{{ trans('advert.is_featured') }}</v-chip>
              </v-flex>
            </v-layout>
          </v-card-title>
        </v-img>
      </v-col>
      <v-col cols="12">
        <div class="d-flex align-stretch flex-column fill-height">
          <v-card-title>
            <v-list-item two-line class="pa-0 item-title">
              <v-list-item-content class="pt-0">
                <v-list-item-subtitle>
                  <span class="body-2">{{ trans('advert.property_type_' + property_type) }}</span>
                  <span>·</span>
                  <span class="body-2">{{ occupants }} persons</span>
                </v-list-item-subtitle>
                <v-list-item-title>
                  <h3>{{ title }}</h3>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action class="mt-0">
                <v-list-item-action-text class="d-flex align-start">{{ moment(created_at) }}</v-list-item-action-text>
              </v-list-item-action>
            </v-list-item>
          </v-card-title>

          <v-card-text>
            <div class="primary--text">
              <span class="title">{{ price_total }}</span>
              <span>{{ price_currency }}/month</span>
            </div>
            <div>{{ address }}</div>
          </v-card-text>
        </div>
      </v-col>
      <v-col cols="12">
        <v-btn
          text
          :disabled="people_interesting < 1"
          :to="{ name: 'advert-details', params: { uuid: uuid } }"
        >
          <v-icon small left color="primary">mdi-star</v-icon>
          <span
            class="d-none d-md-inline"
          >{{ trans('advert.people_interesting', { num: people_interesting }) }}</span>
          <span class="d-inline d-md-none">{{ people_interesting }}</span>
        </v-btn>
      </v-col>
      <v-col cols="12" class="px-3 py-4">
        <v-btn
          rounded
          small
          color="secondary"
          :to="{ name: 'advert-details', params: { uuid: uuid } }"
        >{{ trans('advert.action_show') }}</v-btn>

        <v-btn
          rounded
          small
          color="danger"
          class="mx-1"
          @click="deleteAction"
          :loading="is_deleting"
        >{{ trans('advert.action_delete') }}</v-btn>
        <v-btn
          v-if="status == 'published'"
          rounded
          small
          class="mx-1"
          color="secondary"
          @click="unpublishAction"
          :loading="is_publishing"
        >{{ trans('advert.action_unpublish') }}</v-btn>
        <v-btn
          v-else
          rounded
          small
          color="secondary"
          @click="publishAction"
          :loading="is_publishing"
        >{{ trans('advert.action_publish') }}</v-btn>
        <v-btn rounded small color="primary" @click="editAction">{{ trans('advert.action_edit') }}</v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import _ from "lodash";

export default {
  computed: {
    address: function() {
      return _.get(this.$props, "location.formatted_address", "No address");
    },

    edit_link: function() {
      return {
        name: "my-adverts-edit",
        params: {
          uuid: this.uuid
        }
      };
    },

    thumb_1: function() {
      let url = _.get(this.$props, "images[0].urls.sm", null);
      if (!url) return this.faker.thumb;
      return this.url("media/" + url);
    },

    people_interesting: function() {
      return _.size(this.$props.interesting);
    },

    is_deleting: function() {
      return this.$props.deleting == this.$props.uuid;
    },

    is_publishing: function() {
      return this.$props.publishing == this.$props.uuid;
    }
  },
  methods: {
    deleteAction: function() {
      if (window.confirm(this.trans("advert.delete_confirmation"))) {
        this.$emit("delete", this.$props.uuid);
      }
    },
    editAction: function() {
      this.$emit("edit", this.$props.uuid);
    },
    unpublishAction: function() {
      this.$emit("unpublish", this.$props.uuid);
    },
    publishAction: function() {
      this.$emit("publish", this.$props.uuid);
    }
  },
  props: [
    "uuid",
    "property_type",
    "room_amount",
    "occupants_max",
    "occupants_amount",
    "occupants",
    "owner_type",
    "price_value",
    "price_total",
    "price_currency",
    "rent_period",
    "security_deposit",
    "area",
    "area_unit",
    "transport_mode",
    "transport_duration",
    "transport_from",
    "transport_line",
    "living_room",
    "amenities",
    "facilities",
    "room_size",
    "available_from",
    "bills_included",
    "est_bill_amount",
    "broadband_included",
    "tenant_smoking",
    "tenant_occupation",
    "tenant_pets",
    "tenant_gender",
    "tenant_age_min",
    "tenant_age_max",
    "tenant_language",
    "tenant_couples",
    "flatmate_smoking",
    "flatmate_gender",
    "flatmate_occupation",
    "flatmate_pets",
    "flatmate_age",
    "flatmate_language",
    "flatmate_nationality",
    "flatmate_interests",
    "title",
    "description",
    "has_media",
    "featured",
    "status",
    "created_by",
    "created_at",
    "updated_at",
    "deleted_at",
    "author",
    "images",
    // 'role',
    // 'locale',
    // 'email',
    // 'phone_number',
    // 'first_name',
    // 'last_name',
    // 'email_visible',
    // 'phone_number_visible',
    // 'last_name_visible',
    // 'email_verified',
    // 'phone_number_verified',
    // 'provider',
    // 'locked_at',
    // 'deleted_at',
    // 'filled',
    // 'activity',
    "location",
    // 'uuid',
    // 'property_uuid',
    // 'place_id',
    // 'lat',
    // 'lng',
    // 'quadkey',
    // 'deckey',
    // 'postal_code',
    // 'country',
    // 'state',
    // 'locality',
    // 'sublocality',
    // 'route',
    // 'street_number',
    // 'formatted_address',
    "interesting",

    "editing",
    "deleting",
    "publishing"
  ]
};
</script>